export default __webpack_public_path__ + "static/media/P730MAND2.e5de52e8.pdf";